import { r as readable, w as writable } from "./index2.js";
import { n as navigating } from "./stores.js";
const activeEditorView = writable(null);
const previousPage = readable(null, (set) => {
  const unsubscribe = navigating.subscribe(($navigating) => {
    if ($navigating) {
      set($navigating.from.url.pathname);
    }
  });
  return () => unsubscribe();
});
export {
  activeEditorView as a,
  previousPage as p
};
